import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Company } from "model";

/**
* @class StateTaxID
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.stateTaxIDs[0];
* const contactInfo = new StateTaxID(record);
* @property {NUMBER} _id - The id of the StateTaxID.
* @property {Company} _company - Instance of company to get the company name.
* @property {STRING} _state - Name of the state.
* @property {STRING} _taxID - The tax id.
* @property {STRING} _isSelected - Component specific property for selecting a row using this state tax id.
*/
export default class StateTaxID extends BCMSRecord {
    _id
    _company
    _state
    _taxID
    _taxRevealedID
    _isSelected

    constructor (record){     
      super(record) 
    }
  }

  StateTaxID.define({
    "recordType": "stateTaxIDs",
    "recordIDProp": "id",
    "className" : "StateTaxID",
    "recordProperties":[
      /** 
       * @name id
       * @instance
       * @property get {NUMBER} - gets the id value
       * @property set {NUMBER} - sets the id value
       * @memberof StateTaxID
       */
      BCMSRecordProperty.mapToNumber("id","_id"),

      /** 
       * @name company
       * @instance
       * @property get {STRING} - gets the company value
       * @property set {STRING} - sets the company value
       * @memberof StateTaxID
       */
      BCMSRecordProperty.mapToClass("company","_company", () => Company),

       /** 
       * @name state
       * @instance
       * @property get {STRING} - gets the state value
       * @property set {STRING} - sets the state value
       * @memberof StateTaxID
       */
      BCMSRecordProperty.mapToString("state", "_state"),

       /** 
       * @name taxID
       * @instance
       * @property get {STRING} - gets the taxID value
       * @property set {STRING} - sets the taxID value
       * @memberof StateTaxID
       */
       BCMSRecordProperty.mapToString("taxID", "_taxID"),

      /** 
       * @name taxRevealedID
       * @instance
       * @property get {STRING} - gets the taxRevealedID value
       * @property set {STRING} - sets the taxRevealedID value
       * @memberof StateTaxID
       */
      BCMSRecordProperty.mapToString("taxRevealedID", "_taxRevealedID"),

      /** 
       * @name isSelected
       * @instance
       * @property get {STRING} - gets the isSelected value. This is a component specific value for selecting a row.
       * @property set {STRING} - sets the isSelected value. This is a component specific value for selecting a row.
       * @memberof StateTaxID
       */
      BCMSRecordProperty.mapToString("isSelected", "_isSelected"),
    ]  
})




